import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, ArrowRight, MessageCircle } from "lucide-react";
import { useCart } from "../context/CartContext";
import { openWhatsApp, buildEnquiryMessage } from "../lib/site";
import { CATEGORIES } from "../data/products";

export default function ProductCard({ product }) {
  const [selectedSize, setSelectedSize] = useState(product.variants[0].size);
  const { add } = useCart();
  const variant = product.variants.find((v) => v.size === selectedSize) || product.variants[0];
  const cat = CATEGORIES.find((c) => c.id === product.category);

  const handleAdd = () => add(product, variant, 1);
  const handleWhatsApp = () => openWhatsApp(buildEnquiryMessage(product.name, variant.size));

  return (
    <motion.article className="pcard pcard-text" data-testid={`product-${product.id}`}
      initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 0.61, 0.36, 1] }}>
      <div className="pcard-body">
        <span className="pcard-cat">{cat?.label}</span>
        <div className="pcard-head">
          <h3><Link to={`/products/${product.slug}`}>{product.name}</Link></h3>
          <p>{product.description}</p>
        </div>
        <fieldset className="pcard-sizes">
          <legend className="sr-only">Pack size</legend>
          {product.variants.map((v) => (
            <label key={v.size} className={selectedSize === v.size ? "psize is-active" : "psize"} data-testid={`variant-${product.id}-${v.size}`}>
              <input type="radio" name={`size-${product.id}`} value={v.size} checked={selectedSize === v.size} onChange={() => setSelectedSize(v.size)} />
              <span>{v.size}</span>
            </label>
          ))}
        </fieldset>
        <div className="pcard-actions">
          <button className="pbtn pbtn-primary" onClick={handleAdd} data-testid={`add-${product.id}`}>
            <ShoppingBag size={16} /> Add to Cart
          </button>
          <button className="pbtn pbtn-ghost" onClick={handleWhatsApp} data-testid={`wa-${product.id}`}>
            <MessageCircle size={16} /> WhatsApp
          </button>
          <Link to={`/products/${product.slug}`} className="pcard-view" data-testid={`view-${product.id}`}>
            View details <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </motion.article>
  );
}
